export default "__VITE_ASSET__1807d7c8__"